export { EvaluationPage as default } from '@/components/pages/Ir/Evaluation'
